
import XHeader from 'vux/src/components/x-header/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: 'printHead',
directives: {
TransferDom
},
components: {
XHeader,
Popup
},

props: ['title'],

data () {
return {
showMenus: false
}
},

created () {

},

mounted () {

},

methods: {

}
}



// WEBPACK FOOTER //
// ./src/components/printHead.vue